/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  totalNewAccountsPerDayListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGet,
} from "../../funcs/totalNewAccountsPerDayListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGetRequest$inboundSchema,
};

export const tool$totalNewAccountsPerDayListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGet:
  ToolDefinition<typeof args> = {
    name:
      "new-accounts-till-date-v1",
    description: `List Total New Accounts Got Created Till Date

Original tool name: total-new-accounts-till-date-get

Original tool name: total-new-accounts-per-day-list-till-date-ledgers-ledger-canister-id-total-new-accounts-till-date-get`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await totalNewAccountsPerDayListTotalNewAccountsTillDateApiV1LedgersLedgerCanisterIdTotalNewAccountsTillDateGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };